<!-- 特价申请审核任务 -->
<template>
  <div class='page_content'>
    <processAuditAction ref="processAuditAction"></processAuditAction>

    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
      <div class="page_content_top_line">
        <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="申请人" prop="wosaApperName" min-width="100"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="销往单位" prop="cmName" min-width="160">
          <template slot-scope="scope">
            <span>
              <a @click="toDetail(scope.row.cmId)">{{ scope.row.cmName }}</a>
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="货主" prop="coName" min-width="100"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="申请价格" prop="wosaAppprice" min-width="120"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="最低售价" prop="lowestPrice" min-width="120"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="申请原因" prop="wosaAppreason" min-width="160"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="截止日期" prop="wosaEnddate" min-width="110">
          <template slot-scope="scope">
            <div v-if="scope.row.wosaEnddate">
              {{ $common.getLocalTime(scope.row.wosaEnddate) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="通用名称" prop="bgmName" min-width="160">
          <template slot-scope="scope">
            <span>
              <a @click="toDetail(scope.row.bgmId)">{{ scope.row.bgmName }}</a>
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="生产厂家" prop="manufacturer" min-width="160"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="产地" prop="placeorigin" min-width="60"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="规格" prop="spec" min-width="120"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="bgpUnitmeasurement" label="包装单位" min-width="120"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="packingSpec" label="装箱规格" min-width="110"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="批号" prop="batchno" min-width="120"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="生产日期" prop="prodate" min-width="110">
          <template slot-scope="scope">
            <div v-if="scope.row.prodate">
              {{ $common.getLocalTime(scope.row.prodate) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="有效期" prop="expidate	" min-width="110">
          <template slot-scope="scope">
            <div v-if="scope.row.expidate">
              {{ $common.getLocalTime(scope.row.expidate) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="状态" prop="wosaState" min-width="90">
          <template slot-scope="scope">
            <span>
              {{$common.getIsGsp('[{"key":0,"value":"初始"},{"key":1,"value":"审核退回"},{"key":2,"value":"提交审核"},{"key":3,"value":"审核通过"}]',scope.row.wosaState) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="申请日期" prop="expidate" min-width="110">
          <template slot-scope="scope">
            <div>
              {{ $common.getLocalTime(scope.row.createTime) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="制单人" prop="createrName" min-width="100"></el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchScheme },
  data() {
    //这里存放数据
    return {
      searchList: [
        {
          entityField: "start",
          fieldType: "date",
          formatterContent: null,
          isRequired: 0,
          isShow: 1,
          searchId: null,
          extractId: null,
          setField: null,
          showField: "开始时间",
        },
        {
          entityField: "end",
          fieldType: "date",
          formatterContent: null,
          isRequired: 0,
          isShow: 1,
          searchId: null,
          extractId: null,
          setField: null,
          showField: "结束时间",
        },
        {
          entityField: "cmName",
          fieldType: "search",
          formatterContent: null,
          isRequired: 0,
          isShow: 1,
          searchId: 3391151360249856,
          extractId: null,
          setField: 'cmName,cmId',
          showField: "销往单位",
        },
      ],
      tableHeight: 0,
      getRequestData: {
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,	//开始上一个月
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,	//当天最后时间
        "cmId": '',
        "creater": '',
        "ormId": '',
        cmName: "",

      },
      returnData: {
        pages: 0,  // 总页数
        total: 0,  // 总条数
        pageNum: 0,  // 当前页数
        list: []
      },

      buttonList: [],

      selectedDataIndex: 0,
      seTitle: "",//检索
      DialogVisible: false,
      seWidth: '0',
      seId: 0,
      sField: "",
      cmId: 0,
      parentSearchData: {},
      selectVal: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.cmName"() {
      if (this.getRequestData.cmName == '') {
        this.getRequestData.cmId = ''
      }
    },
  },
  //方法集合
  methods: {
    handleSelectionChange(val) {
      this.selectVal = val
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({  //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: { isPenetrate } //参数
        }, '*');
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true
      this.seId = sId
      this.sField = sField
      this.parentSearchData[sField] = this.getRequestData[sField]
    },
    //检索带回数据
    changeInputModel(val) {
      // console.log(val);

      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (val.cmId) {//销售单位
          this.cmId = val.cmId
        }
        this.paramValue(val)
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    getSeWidth(e) {
      // console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      // console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      // console.log(e);
      this.seTitle = e;
    },
    isShowData(name, value) {
      switch (name) {
        case 'cmId':
          var info = sessionStorage.getItem('selectCustomerData')
          if (info) {
            let infoTwo = JSON.parse(info)
            this.getRequestData.cmName = infoTwo.cmName
          }
          this.getRequestData[name] = value
          break;
        default:
          this.getRequestData[name] = value
      }
    },

    // 动作集合
    actionSet(actionData) {
      if (actionData.actionType != 15) {

        if (this.selectVal.length == 0) {
          this.$message({
            message: "请先选择您要操作的数据",
            type: "error",
          });
          return false;
        }
        var dataInfo = JSON.parse(
          JSON.stringify(this.returnData.list[this.selectedDataIndex])
        );
      }
      switch (actionData.actionType) {
        case 4:
          var arr = []
          this.selectVal.forEach(item => {
            arr.push(item.wosaId)
          })
          this.$refs["processAuditAction"].openBox(0, arr);
          // this.$refs['processAuditAction'].openBox(0, dataInfo.wosaId)
          break;
        case 5:
          if (this.selectVal.length > 1) {
            this.$message({
              message: "请勾选一条数据",
              type: "error",
            });
            return false;
          }
          this.$refs["processAuditAction"].openBox(1, this.selectVal[0].wosaId);
          // this.$refs['processAuditAction'].openBox(1, dataInfo.wosaId)
          break;
      }
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },


    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.getSpecialPriceApplyTask(this.getRequestData)
      if (responseData && responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
        this.selectedDataIndex = 0
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
    for (const key in obj) {
      this.$set(this.getRequestData, key, obj[key])
    }
    this.getDataList()
    this.getButtonList()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>
